module.exports = __webpack_public_path__ + "img/three_column1.6553999b.png";